import * as React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import { useGraphQL, useLazyLoad } from '../hooks';
import { resizeShopifyImage } from '../utilities';

import { DiagonalBanner } from './diagonal-banner';

function Tile({
  title,
  slug,
  price,
  image,
  constantPrice,
  available,
  onSale = false,
}) {
  const { placeholderImage } = useGraphQL();

  let imageSrc = placeholderImage.publicURL;
  if (image?.originalSrc)
    imageSrc = resizeShopifyImage({ url: image.originalSrc, width: 300 });
  if (typeof image === 'string') imageSrc = image;

  const { ref, srcRef, isLoaded, handleIsLoaded, Spinner } = useLazyLoad();
  return (
    <Link
      ref={ref}
      to={slug}
      className={`${
        !available && 'opacity-50'
      } relative flex flex-col w-full max-w-sm pb-3 mx-auto overflow-hidden transition duration-150 ease-in-out transform bg-white h-96 group focus:outline-none focus:shadow-outline-primary focus:z-10`}
    >
      <div className="relative h-64">
        <img
          ref={srcRef}
          onLoad={handleIsLoaded}
          data-src={imageSrc}
          alt=""
          className="object-contain w-full h-full duration-500 ease-in-out transform bg-white group-hover:scale-110 group-focus:scale-110"
        />
        {!isLoaded && <Spinner />}
        {onSale && available && <DiagonalBanner bannerText="On Sale" />}
        {!available && <DiagonalBanner bannerText="Sold Out" />}
      </div>
      <div className="p-6">
        <h3 className="mt-2 clamp-2">{title}</h3>
        <p className="mt-3 text-base leading-6 text-gray-500">
          {!constantPrice && `Starting from: `}
          {available ? (
            <span className="font-bold text-black">
              <small className="font-normal">AUD</small> ${price.toFixed(2)}
            </span>
          ) : (
            <span className="font-bold text-black">Sold Out</span>
          )}
        </p>
      </div>
    </Link>
  );
}

Tile.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  price: PropTypes.number.isRequired,
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  constantPrice: PropTypes.bool.isRequired,
  available: PropTypes.bool.isRequired,
  onSale: PropTypes.bool,
};

export { Tile };
